module.exports = __webpack_public_path__ + "static/media/min.3b818de6.svg";